import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';
import { Observable, throwError } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RemovePromoOfferService {

  constructor(private http: HttpService) { }

  getRemovePromoOffer(data): Observable<any> {
    const booking_id = data?.booking_info?.id;
    return this.http.flightsave(`apiV2/bookingClass/remove-promo-code`, { booking_id }).pipe(
      switchMap(res => {
        if (res?.statusCode !== 200) {
          return throwError(() => new Error(`Remove promo failed with response: ${JSON.stringify(res)}`));
        }
        const bookingId = booking_id;
        return this.http.flightsave(`apiV2/user/booking-info`, { booking_id: bookingId });
      }),
      catchError(err => throwError(() => err))
    );
  }
}
